module.exports = __webpack_public_path__ + "img/notbanner.76495ccb.png";